export const tableColumns = [
    {
        key: "index",
        label: "A/A",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "onoma",
        label: "Όνομα",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "epwnymo",
        label: "Επώνυμο",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "email",
        label: "E-mail",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "afm",
        label: "Α.Φ.Μ.",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "strkProsKwd",
        label: "Α.Μ.",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "workTelephone",
        label: "Τηλέφωνο",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "idRole",
        label: "Είδος Διαχειριστή",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "blocked",
        label: "Κατάσταση",
        sortable: true,
        tdClass: "align-middle"
    },
    {
        key: "actions",
        label: "Ενέργειες",
        sortable: false,
        tdClass: "align-middle"
    }
]
